import { Component, SimpleChanges, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputControlBase } from '../base/input-control-base/input-control.base';

@Component({
  selector: 'input-checkbox-control',
  templateUrl: './input-checkbox-control.component.html',
  styleUrls: ['./input-checkbox-control.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCheckboxControlComponent),
      multi: true
    }
  ]
})
export class InputCheckboxControlComponent extends InputControlBase<boolean> {
  public defaultCss = 'form-check-input';

  @Input('css')
  css: string = '';

  constructor(){
    super();
  }
  protected onInit(): void {
    this.initCss();
  }  
  protected onDestroy(): void {
  }
  protected onChanges(changes: SimpleChanges): void {
  }
  protected onDoCheck(): void {
  }
  protected onAfterContentInit(): void {
  }
  protected onAfterContentChecked(): void {
  }
  protected onAfterViewInit(): void {
  }
  protected onAfterViewChecked(): void {
  }

  private initCss() {
    this.defaultCss += ` ${this.css}`;
  }
  
}
